<template>
    <div>
        <vs-popup
                class="vehicle-modal"
                title="Categorie bewerken"
                :active.sync="showPopup"
                v-if="category !== null"
        >
            <template>
                <div class="vx-row">
                    <div class="vx-col w-full">
                        <vs-input v-model="category.name" label="Naam" class="w-full"></vs-input>
                    </div>
                </div>
                <br>

                <div class="vx-col">
                    <vs-button
                            class="mr-3 mb-2 vs-con-loading__container"
                            id="save-company-category-button"
                            ref="loadableButton"
                            @click="saveCompanyCategory"
                            :disabled="canSave"
                            style="float: right"
                    >Opslaan
                    </vs-button>
                </div>
            </template>
        </vs-popup>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                category: null,
                showPopup: false,
                showCreatePopup: false
            };
        },
        computed: {
            canSave() {
                return this.category.name === "";
            }
        },
        methods: {
            saveCompanyCategory() {
                this.$util.loading('#save-company-category-button', this.$vs);
                this.loading = true;
                let data = new FormData();
                data.append('_method', 'PUT');
                data.append('id', this.category.id);
                data.append('name', this.category.name);
                this.$http
                    .post("v1/company-category/update", data, {
                        headers: {
                            Authorization:
                                "Bearer " + JSON.parse(localStorage.getItem("stafftoken")),
                        },
                    })
                    .then(() => {
                        this.showPopup = false;
                        this.loading = false;
                        this.$vs.loading.close('#save-company-category-button > .con-vs-loading');
                        this.$util.notify('Gelukt', 'Categorie is opgeslagen', this.$vs);
                    })
                    .catch((error) => {
                        this.$vs.loading.close("#save-company-category-button > .con-vs-loading");
                        this.loading = false;
                        this.$util.logError(error, this.$vs);
                    });
            },
        },
        mounted() {
            this.$events.listen('open-category-popup', (category) => {
                this.category = category;
                this.showPopup = true;
            });
        }
    };
</script>